export class ImageUtils {
    static getResizedCloudinaryUrl(originalUrl: string, width: number = 200, height: number = 200): string {
      if (!originalUrl) return 'assets/images/No-Image.png';
  
      const parts = originalUrl.split('/upload/');
      if (parts.length === 2) {
        return `${parts[0]}/upload/w_${width},h_${height},c_fill/${parts[1]}`;
      }
  
      return originalUrl;
    }
  }
  